import { render, staticRenderFns } from "./delegatedControl.vue?vue&type=template&id=519aeae8&scoped=true"
import script from "./delegatedControl.vue?vue&type=script&lang=js"
export * from "./delegatedControl.vue?vue&type=script&lang=js"
import style0 from "./delegatedControl.vue?vue&type=style&index=0&id=519aeae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519aeae8",
  null
  
)

export default component.exports